import ViewDriverApp from '@/views/driver-app/ViewDriverApp.vue'
import ViewJourneyDetails from '@/views/driver-app/ViewJourneyDetails.vue'
import ViewJourneyPhoto from '@/views/driver-app/ViewJourneyPhoto.vue'
import ViewJourneySignature from '@/views/driver-app/ViewJourneySignature.vue'
import ViewJourneySurvey from '@/views/driver-app/ViewJourneySurvey.vue'
import ViewJourneyConfirm from '@/views/driver-app/ViewJourneyConfirm.vue'

export default [
	{
		path: '/driver-app',
		name: 'driver-app-dashboard',
		component: ViewDriverApp,
		meta: {
			navigation: false,
			driverBar: true,
			permissions: ['view-driver-app']
		}
	},
	{
		path: '/driver-app/journey/:id/details',
		name: 'driver-app-details',
		component: ViewJourneyDetails,
		meta: {
			navigation: false,
			driverBar: true,
			permissions: ['view-driver-app']
		}
	},
	{
		path: '/driver-app/journey/:id/photo',
		name: 'driver-app-journey-photo',
		component: ViewJourneyPhoto,
		meta: {
			navigation: false,
			driverBar: true,
			permissions: ['view-driver-app']
		}
	},
	{
		path: '/driver-app/journey/:id/signature',
		name: 'driver-app-journey-signature',
		component: ViewJourneySignature,
		meta: {
			navigation: false,
			driverBar: true,
			permissions: ['view-driver-app']
		}
	},
	{
		path: '/driver-app/journey/:id/survey',
		name: 'driver-app-journey-survey',
		component: ViewJourneySurvey,
		meta: {
			navigation: false,
			driverBar: true,
			permissions: ['view-driver-app']
		}
	},
	{
		path: '/driver-app/journey/:id/confirm',
		name: 'driver-app-journey-confirm',
		component: ViewJourneyConfirm,
		meta: {
			navigation: false,
			driverBar: true,
			permissions: ['view-driver-app']
		}
	}
]
